import React from 'react';
import './ProofStrip.css';

const items = [
  'Medspas & Cosmetic Clinics',
  'Insurance, Mortgage & Real Estate',
  'Law & Accounting Firms',
  'Veterinary Clinics, Gyms, Auto Dealerships & Trades',
];

const ProofStrip = () => (
  <div className="proof-strip">
    <div className="container">
      <div className="proof-strip-inner">
        {items.map((item, i) => (
          <React.Fragment key={item}>
            <span className="proof-item">{item}</span>
            {i < items.length - 1 && <span className="proof-divider" aria-hidden="true" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
);

export default ProofStrip;
